import { HttpResponse, http } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import type { GetToursApiResponse } from '../../../src/store/facade/facadeApiV3';
import { TourStatus } from '../../../src/store/facade/facadeApiV3';

const getURL = `${BASE_URL_V3}${API.endpoints.tour}`;

const daysFromNow = (days: number) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString();
};

export const toursListMock: GetToursApiResponse = {
    totalCount: 4,
    tours: [
        {
            tourId: 'ddcdffec-9666-4c39-ba8e-f66505fa3207',
            status: TourStatus.InProgress,
            createAt: daysFromNow(-1),
            lastUpdate: daysFromNow(0),
            departureAddress: {
                street: 'Praça de Almeida Garrett',
                number: '49',
                city: 'Porto',
                countryCode: 'PRT',
                postalCode: '4000-069',
            },
            arrivalAddress: {
                street: 'Avenida Fontes Pereira de Melo',
                city: 'Lisboa',
                countryCode: 'PRT',
                postalCode: '1050-115',
            },
            itinerarySummary: {
                totalDuration: 14400,
                totalDistance: 320000,
                departureEvent: { estimatedDay: daysFromNow(0) },
            },
        },
        {
            tourId: '5a3e778e-67cc-43d5-9021-e0c7659a6dbe',
            status: TourStatus.Draft,
            createAt: daysFromNow(-30),
            lastUpdate: daysFromNow(-29),
            departureAddress: {
                street: 'Rua da Universidade',
                city: 'Coimbra',
                countryCode: 'PRT',
                postalCode: '3000-000',
            },
            arrivalAddress: {
                street: 'Avenida da Liberdade',
                city: 'Lisboa',
                countryCode: 'PRT',
                postalCode: '1250-000',
            },
            itinerarySummary: {
                totalDuration: 7200,
                totalDistance: 200000,
                departureEvent: { estimatedDay: daysFromNow(-15) },
            },
        },
        {
            tourId: '95c90bfb-9983-43a5-b0e5-2c462744c260',
            status: TourStatus.Synchronized,
            createAt: daysFromNow(-60),
            lastUpdate: daysFromNow(-59),
            departureAddress: {
                street: 'Rua de Santa Catarina',
                city: 'Porto',
                countryCode: 'PRT',
                postalCode: '4000-450',
            },
            arrivalAddress: {
                street: 'Praça do Comércio',
                city: 'Lisboa',
                countryCode: 'PRT',
                postalCode: '1100-148',
            },
            itinerarySummary: {
                totalDuration: 10800,
                totalDistance: 310000,
                departureEvent: { estimatedDay: daysFromNow(-45) },
            },
        },
        {
            tourId: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
            status: TourStatus.Draft,
            createAt: daysFromNow(-2),
            lastUpdate: daysFromNow(-1),
            departureAddress: {
                street: 'Avenida dos Aliados',
                city: 'Porto',
                countryCode: 'PRT',
                postalCode: '4000-064',
            },
            arrivalAddress: {
                street: 'Rua Augusta',
                city: 'Lisboa',
                countryCode: 'PRT',
                postalCode: '1100-053',
            },
            itinerarySummary: {
                totalDuration: 12600,
                totalDistance: 315000,
                departureEvent: { estimatedDay: daysFromNow(30) },
            },
        },
    ],
};

export const GetToursHandler = http.get(getURL, () => {
    return HttpResponse.json(toursListMock);
});
